import React from 'react'
import { Paper, Tab, Tabs, Typography, Box } from '@mui/material'
import { useAppSelector } from '../../../app/hooks'
import { selectAuthUserPendingSettlementsAvailable, selectAuthUserSettlementsEnabled } from '../../auth/authSlice'
import ProfileTabComponent from '../components/profile/ProfileTabComponent'
import SolarProjectsList from '../components/solar-projects/SolarProjectsList'
import FinanceTabComponent from '../components/finance/FinanceTabComponent'
import { useAuth } from '../../auth/provider/AuthProvider'
import PortfolioSettlementTabComponent from '../components/portfolio-settlements/PortfolioSettlementTabComponent'

export interface AssetHolderIdProps {
  assetHolderId: number
}

const DashboardHome: React.FC = () => {
  const { assetHolderId } = useAuth()
  const userSettlementsEnabled = useAppSelector(selectAuthUserSettlementsEnabled)
  const userPendingSettlementsAvailable = useAppSelector(selectAuthUserPendingSettlementsAvailable)

  const selectedTabIndex = (idx: number): number => {
    return userSettlementsEnabled ? idx : idx - 1
  }

  const startTabIndex = userSettlementsEnabled
    ? userPendingSettlementsAvailable ? 0 : 1
    : 0

  const [tabIndex, setTabIndex] = React.useState(startTabIndex)

  const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
    setTabIndex(newValue)
  }

  const a11yTabProps = (index: number): any => {
    return {
      id: `dashboard-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    }
  }

  const a11yTabPanelProps = (index: number): any => {
    const newIndex = selectedTabIndex(index)
    return {
      id: `dashboard-tab-panel-${newIndex}`,
      'aria-controls': `simple-tabpanel-${newIndex}`
    }
  }

  return (
    <>
      <Paper sx={{ mb: 5, width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabIndex}
                onChange={handleChange}
                aria-label="dashboard-tabs"
                variant="scrollable"
                scrollButtons="auto"
                // scrollButtons={true}
                // allowScrollButtonsMobile
                sx={{ p: 0 }}>
            {userSettlementsEnabled && (
              <Tab label={<Typography variant={'h4'} sx={{ p: 2 }}>Portfolio Settlements</Typography>} {...a11yTabProps(0)} />
            )}
            <Tab label={<Typography variant={'h4'} sx={{ p: 2 }}>My Solar Cells</Typography>} {...a11yTabProps(1)} />
            <Tab label={<Typography variant={'h4'} sx={{ p: 2 }}>My Wallets</Typography>} {...a11yTabProps(2)} />
            <Tab label={<Typography variant={'h4'} sx={{ p: 2 }}>My Profile</Typography>} {...a11yTabProps(3)} />
          </Tabs>
        </Box>

        {userSettlementsEnabled && (
          <Box role="tabpanel" hidden={tabIndex !== 0} {...a11yTabPanelProps(0)}>
            {tabIndex === selectedTabIndex(0) && (
              <Box sx={{ p: 4 }}>
                <PortfolioSettlementTabComponent assetHolderId={assetHolderId}/>
              </Box>
            )}
          </Box>
        )}

        <Box role="tabpanel" hidden={tabIndex !== selectedTabIndex(1)} {...a11yTabPanelProps(1)}>
          {/* <Box sx={{ p: 4 }}> */}
          {tabIndex === selectedTabIndex(1) && (
            <Box sx={{ py: 4 }}>
              <SolarProjectsList assetHolderId={assetHolderId}/>
            </Box>
          )}
          {/* </Box> */}
        </Box>

        <Box role="tabpanel" hidden={tabIndex !== selectedTabIndex(2) } {...a11yTabPanelProps(2)}>
          {tabIndex === selectedTabIndex(2) && (
            <Box sx={{ p: 4 }} >
              <FinanceTabComponent assetHolderId={assetHolderId}/>
            </Box>
          )}
        </Box>

        <Box role="tabpanel" hidden={tabIndex !== selectedTabIndex(3)} {...a11yTabPanelProps(3)}>
          {tabIndex === selectedTabIndex(3) && (
            <Box sx={{ p: 4 }}>
              <ProfileTabComponent/>
            </Box>
          )}
        </Box>
      </Paper>
    </>
  )
}

export default DashboardHome
